import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { ErrorHandler } from '@angular/core';
import { BusinessAdminNote } from '../models/business-admin-notes.model';
import { AuthEventType } from '../../auth/models/auth-event.model';
import { AuthService } from '../../auth/auth/auth.service';
import { UserService } from '../../shared/user/user.service';
import { environment } from '../../../environments/environment';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
import { BusinessAdminNotesDates } from '../models/business-admin-notes-dates';
var BusinessAdminNotesService = /** @class */ (function () {
    function BusinessAdminNotesService(_http, _auth, _userService, _errorHandler, _businessManagerService) {
        var _this = this;
        this._http = _http;
        this._auth = _auth;
        this._userService = _userService;
        this._errorHandler = _errorHandler;
        this._businessManagerService = _businessManagerService;
        this._auth.authStream.subscribe(function (e) { return _this._onAuthEvent(e); });
    }
    BusinessAdminNotesService.prototype._onAuthEvent = function (e) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!e) {
                            return [2 /*return*/];
                        }
                        _a = e.type;
                        switch (_a) {
                            case AuthEventType.SignIn: return [3 /*break*/, 1];
                            case AuthEventType.InvalidSignIn: return [3 /*break*/, 3];
                            case AuthEventType.SignOut: return [3 /*break*/, 3];
                        }
                        return [3 /*break*/, 4];
                    case 1:
                        _b = this;
                        return [4 /*yield*/, this._userService.getUserInfo()];
                    case 2:
                        _b.userInfo = _c.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        this.userInfo = null;
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Gets all the businessAdminNotes based on the businessID from the API.
     * Requires that user is a flight deck admin
     * @param businessId {number} Business ID
     * @returns {Promise<Array<Business>>} BusinessAdminNotes
     */
    BusinessAdminNotesService.prototype.getBusinessAdminNotes = function (businessId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b, ERROR, URL, RESPONSE, BUSINESS_ADMIN_NOTES_DATES, ERROR, e_1;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = !this._auth.authenticated || !this._auth.token || !this._auth.endUser;
                        if (_a) return [3 /*break*/, 4];
                        return [4 /*yield*/, this._businessManagerService.isFlightDeckAdmin()];
                    case 1:
                        _b = (_c.sent());
                        if (_b) return [3 /*break*/, 3];
                        return [4 /*yield*/, this._businessManagerService.isAmbassador()];
                    case 2:
                        _b = (_c.sent());
                        _c.label = 3;
                    case 3:
                        _a = !(_b);
                        _c.label = 4;
                    case 4:
                        if (_a) {
                            ERROR = new Error('User not authorized');
                            this._errorHandler.handleError(ERROR);
                            throw ERROR;
                        }
                        URL = environment.airportsApiUrl + "/business/" + businessId + "/adminNotes";
                        _c.label = 5;
                    case 5:
                        _c.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, this._http.get(URL).toPromise()];
                    case 6:
                        RESPONSE = _c.sent();
                        BUSINESS_ADMIN_NOTES_DATES = BusinessAdminNotesDates.parse(RESPONSE);
                        if (!BUSINESS_ADMIN_NOTES_DATES) {
                            ERROR = new Error('API did not return valid business admin notes object');
                            this._errorHandler.handleError(ERROR);
                            throw ERROR;
                        }
                        else {
                            return [2 /*return*/, BUSINESS_ADMIN_NOTES_DATES.notes];
                        }
                        return [3 /*break*/, 8];
                    case 7:
                        e_1 = _c.sent();
                        this._errorHandler.handleError(e_1);
                        throw e_1;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Method creates a new businessAdminNote in the API Server via a post request with the string, note.
     * Requires that user is a flight deck admin
     * @param businessId {number} used to identify the business
     * @param note {string} contents for the note
     * @returns {Promise<BusinessAdminNote>} API Server will respond with a new Business OBJ.
     */
    BusinessAdminNotesService.prototype.createBusinessAdminNote = function (businessId, note) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b, ERROR, URL, RESPONSE, BUSINESS_ADMIN_NOTE, ERROR, e_2;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = !this._auth.authenticated || !this._auth.token || !this._auth.endUser;
                        if (_a) return [3 /*break*/, 4];
                        return [4 /*yield*/, this._businessManagerService.isFlightDeckAdmin()];
                    case 1:
                        _b = (_c.sent());
                        if (_b) return [3 /*break*/, 3];
                        return [4 /*yield*/, this._businessManagerService.isAmbassador()];
                    case 2:
                        _b = (_c.sent());
                        _c.label = 3;
                    case 3:
                        _a = !(_b);
                        _c.label = 4;
                    case 4:
                        if (_a) {
                            ERROR = new Error('User not authorized');
                            this._errorHandler.handleError(ERROR);
                            throw ERROR;
                        }
                        URL = environment.airportsApiUrl + "/business/" + businessId + "/adminNote/";
                        _c.label = 5;
                    case 5:
                        _c.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, this._http.post(URL, { note: note }).toPromise()];
                    case 6:
                        RESPONSE = _c.sent();
                        BUSINESS_ADMIN_NOTE = BusinessAdminNote.parse(RESPONSE);
                        if (!BUSINESS_ADMIN_NOTE) {
                            ERROR = new Error('API did not return valid business admin note object');
                            this._errorHandler.handleError(ERROR);
                            throw ERROR;
                        }
                        else {
                            return [2 /*return*/, BUSINESS_ADMIN_NOTE];
                        }
                        return [3 /*break*/, 8];
                    case 7:
                        e_2 = _c.sent();
                        this._errorHandler.handleError(e_2);
                        throw e_2;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Sends put request to api server to update a given business admin note.
     * Method updates the API Server with data from the json object with one field of note being passed in.
     * Requires that user is a flight deck admin
     * @param businessId {number} businessId
     * @param noteId {number} the note that will be updated
     * @param note {string} content to be updated.
     * @returns {Promise<BusinessAdminNote>} API Server will respond with updated Business OBJ.
     */
    BusinessAdminNotesService.prototype.updateBusinessAdminNote = function (businessId, noteId, note) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b, ERROR, URL, RESPONSE, BUSINESS_ADMIN_NOTE, ERROR, e_3;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = !this._auth.authenticated || !this._auth.token || !this._auth.endUser;
                        if (_a) return [3 /*break*/, 4];
                        return [4 /*yield*/, this._businessManagerService.isFlightDeckAdmin()];
                    case 1:
                        _b = (_c.sent());
                        if (_b) return [3 /*break*/, 3];
                        return [4 /*yield*/, this._businessManagerService.isAmbassador()];
                    case 2:
                        _b = (_c.sent());
                        _c.label = 3;
                    case 3:
                        _a = !(_b);
                        _c.label = 4;
                    case 4:
                        if (_a) {
                            ERROR = new Error('User not authorized');
                            this._errorHandler.handleError(ERROR);
                            throw ERROR;
                        }
                        URL = environment.airportsApiUrl + "/business/" + businessId + "/adminNote/" + noteId;
                        _c.label = 5;
                    case 5:
                        _c.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, this._http.put(URL, { note: note }).toPromise()];
                    case 6:
                        RESPONSE = _c.sent();
                        BUSINESS_ADMIN_NOTE = BusinessAdminNote.parse(RESPONSE);
                        if (!BUSINESS_ADMIN_NOTE) {
                            ERROR = new Error('API did not return valid business admin note object');
                            this._errorHandler.handleError(ERROR);
                            throw ERROR;
                        }
                        else {
                            return [2 /*return*/, BUSINESS_ADMIN_NOTE];
                        }
                        return [3 /*break*/, 8];
                    case 7:
                        e_3 = _c.sent();
                        this._errorHandler.handleError(e_3);
                        throw e_3;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Method to call API to delete a business admin note from a business
     * Requires that user is a flight deck admin to delete notes
     * @param businessId {number} the business to remove the admin from.
     * @param noteId {number} the specific note to be deleted as an admin of this business.
     * @returns {Promise<string>} Returns SUCCESS or error message for display to user.
     */
    BusinessAdminNotesService.prototype.deleteBusinessAdminNote = function (businessId, noteId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b, ERROR, URL, RESPONSE, e_4;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = !this._auth.authenticated || !this._auth.token || !this._auth.endUser;
                        if (_a) return [3 /*break*/, 4];
                        return [4 /*yield*/, this._businessManagerService.isFlightDeckAdmin()];
                    case 1:
                        _b = (_c.sent());
                        if (_b) return [3 /*break*/, 3];
                        return [4 /*yield*/, this._businessManagerService.isAmbassador()];
                    case 2:
                        _b = (_c.sent());
                        _c.label = 3;
                    case 3:
                        _a = !(_b);
                        _c.label = 4;
                    case 4:
                        if (_a) {
                            ERROR = new Error('User not authorized');
                            this._errorHandler.handleError(ERROR);
                            throw ERROR;
                        }
                        URL = environment.airportsApiUrl + "/business/" + businessId + "/adminNote/" + noteId;
                        _c.label = 5;
                    case 5:
                        _c.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, this._http.delete(URL).toPromise()];
                    case 6:
                        RESPONSE = _c.sent();
                        return [2 /*return*/, true];
                    case 7:
                        e_4 = _c.sent();
                        this._errorHandler.handleError(e_4);
                        throw false;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Gets all the businessAdminNotes based on the businessID from the API.
     * Requires that user is a flight deck admin
     * @param businessId {number} Business ID
     * @returns {Promise<Array<Business>>} BusinessAdminNotes
     */
    BusinessAdminNotesService.prototype.getBusinessAdminDates = function (businessId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, ERROR, URL, RESPONSE, BUSINESS_ADMIN_NOTES_DATES, ERROR, e_5;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = !this._auth.authenticated || !this._auth.token || !this._auth.endUser;
                        if (_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._businessManagerService.isFlightDeckAdmin()];
                    case 1:
                        _a = !(_b.sent());
                        _b.label = 2;
                    case 2:
                        if (_a) {
                            ERROR = new Error('User not authorized');
                            this._errorHandler.handleError(ERROR);
                            throw ERROR;
                        }
                        URL = environment.airportsApiUrl + "/business/" + businessId + "/adminNotes";
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, this._http.get(URL).toPromise()];
                    case 4:
                        RESPONSE = _b.sent();
                        BUSINESS_ADMIN_NOTES_DATES = BusinessAdminNotesDates.parse(RESPONSE);
                        if (!BUSINESS_ADMIN_NOTES_DATES) {
                            ERROR = new Error('API did not return valid business admin notes object');
                            this._errorHandler.handleError(ERROR);
                            throw ERROR;
                        }
                        else {
                            return [2 /*return*/, BUSINESS_ADMIN_NOTES_DATES.changeLog];
                        }
                        return [3 /*break*/, 6];
                    case 5:
                        e_5 = _b.sent();
                        this._errorHandler.handleError(e_5);
                        throw e_5;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    return BusinessAdminNotesService;
}());
export { BusinessAdminNotesService };
